/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RequestCompetitorStoreRequest } from '../models/RequestCompetitorStoreRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RequestApplyControllerService {
    /**
     * @param competitorCode
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static requestCompetitorStore(
        competitorCode: string,
        requestBody: RequestCompetitorStoreRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/request-apply/competitor/stores/{competitorCode}',
            path: {
                'competitorCode': competitorCode,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
